import { Loader } from 'Molecules/index.ts';
import { TaskListRow, TaskListTable } from './TaskListTable.tsx';
import { EmptyState } from 'Atoms/index.ts';
import { useNavigate, useParams } from 'react-router-dom';
import { SelectedAssessmentOption } from './TaskManagement.tsx';
import { Box } from '@chakra-ui/react';
import { TasksEmptyState } from 'containers/Esrs/pieces/DisclosureRequirements/Metrics/Metrics/MetricsComponents/TasksEmptyState.tsx';

interface TaskListProps {
  taskList: TaskListRow[];
  selectedAssessment?: SelectedAssessmentOption;
  selectedTasks?: string[];
  setSelectedTasks?: (val: string[]) => void;
  searchQuery?: string;
  resetFilters?: () => void;
  isHomepage?: boolean;
}

const TaskListEmptyState = ({
  selectedAssessment,
}: {
  selectedAssessment?: SelectedAssessmentOption;
}) => {
  const navigate = useNavigate();
  const { companyId = '' } = useParams();
  return (
    <EmptyState
      title="You currently don't have any tasks assigned."
      description="You can still contribute to your company's report just like before."
      callToAction={{
        text: 'Go to assessment',
        onClick: () =>
          navigate(
            `/${companyId}/sustainability-reporting/${selectedAssessment?.frameworkRef}/${selectedAssessment?.id}`,
            {
              replace: true,
            }
          ),
        variant: 'secondary',
      }}
      variant="gray"
      component={true}
    />
  );
};

export const TaskList = ({
  taskList,
  selectedAssessment,
  selectedTasks,
  setSelectedTasks,
  searchQuery,
  resetFilters,
  isHomepage,
}: TaskListProps) => {
  if (selectedAssessment === undefined) {
    return <Loader />;
  } else if (!taskList.length && searchQuery?.length) {
    return (
      <TasksEmptyState
        resetFilter={resetFilters}
        customTitle="Current filters do not match any tasks."
        customBody="Reset your filters to to view the content on this page."
        customButtonText="Reset filters"
      />
    );
  } else if (taskList.length === 0) {
    return <TaskListEmptyState selectedAssessment={selectedAssessment} />;
  } else {
    return (
      <Box pb={isHomepage ? '' : '100px'} width="100%">
        <TaskListTable
          data={taskList}
          setSelectedTasks={setSelectedTasks}
          selectedTasks={selectedTasks}
          isHomepage={isHomepage}
        />
      </Box>
    );
  }
};
